import classnames from "classnames";
import styles from "../styles/LeaderboardTable.module.scss";

// Get the right styles for each of the leaderboard elements
export const getLeaderboardStyles = (isTwoColumn?: boolean) => ({
  table: classnames(
    styles.lbTable,
    isTwoColumn ? styles.lbTable_Col2 : styles.lbTable_Col1
  ),
  col: isTwoColumn ? styles.lbTable_Col2Column : styles.lbTable_Col1Column,
  row: isTwoColumn ? styles.lbTable_Col2Row : styles.lbTable_Col1Row,
  rowGroup: isTwoColumn
    ? styles.lbTable_Col2RowGroup
    : styles.lbTable_Col1RowGroup,
  userRank: classnames(
    isTwoColumn ? styles.lbTable_Col2UserRank : styles.lbTable_Col1UserRank,
    styles.rightSpacing
  ),
  userName: isTwoColumn
    ? styles.lbTable_Col2UserName
    : styles.lbTable_Col1UserName,
  userScores: classnames(
    isTwoColumn ? styles.lbTable_Col2UserScores : styles.lbTable_Col1UserScores,
    styles.rightSpacing
  ),
  userProfile: classnames(
    isTwoColumn
      ? styles.lbTable_Col2UserProfile
      : styles.lbTable_Col1UserProfile,
    styles.rightSpacing
  ),
  title: isTwoColumn ? styles.lbTable_Col2Title : styles.lbTable_Col1Title,
  shield: classnames(
    styles.lbTableIcon,
    styles.lbTableShield,
    styles.rightSpacing
  ),
  badge: classnames(styles.lbTableIcon, styles.lbTableBadge),
});
